<template>
  <div>
    <a-card title="仓库">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px;">
          <a-select v-model="searchForm.is_active" placeholder="状态" allowClear style="width: 100%;" @change="search">
            <a-select-option key="filter_true" :value="true">激活</a-select-option>
            <a-select-option key="filter_false" :value="false">冻结</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="编号, 名称, 备注" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <a-col :span="24" style="width: 300px; margin-bottom: 12px;">
          <a-button-group>
            <a-button icon="file-excel" @click="downloadTemplate">模板下载</a-button>
            <a-upload name="file" :showUploadList="false" :customRequest="importExcel">
              <a-button icon="upload">导入</a-button>
            </a-upload>
            <a-button icon="download" @click="exportExcel">导出</a-button>
          </a-button-group>
        </a-col>

        <div style="margin-bottom: 12px; float: right;">
          <a-button type="primary" icon="plus" style="margin: 0 8px;" @click="openFormModal(form)">新增仓库</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange"
>
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? '激活' : '冻结' }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal v-model="visible" :form="targetItem" :usersOptions="usersOptions" @create="create" @update="update" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div>
        <a-spin style="margin-right: 12px;" />正在导入中, 请等待...
      </div>
    </a-modal>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/excel'
import { warehouseExport } from '@/api/export'
import { warehouseTemplate, warehouseImport } from '@/api/import'
import { warehouseList, warehouseDestroy } from '@/api/basicData'
import { getWarehouseNumber } from '@/api/data'
import { userOption } from '@/api/option'

export default {
  name: 'Warehouse',
  components: {
    FormModal: () => import('./FormModal.vue'),
  },
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
        },
        {
          title: '仓库编号',
          dataIndex: 'number',
        },
        {
          title: '仓库名称',
          dataIndex: 'name',
          sorter: true,
        },
        {
          title: '状态',
          dataIndex: 'is_active',
          scopedSlots: { customRender: 'is_active' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '156px'
        },
      ],
      searchForm: { search: '', page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 50 },
      loading: false,
      items: [],
      usersOptions: [],
      visible: false,
      targetItem: { manager_id: null, is_active: true },
      form: { manager_id: null, is_active: true },
      importLoading: false,
    };
  },
  computed: {
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.list();
    },
    list() {
      this.loading = true;
      warehouseList(this.searchForm).then(data => {
        this.pagination.total = data.count;
        this.items = data.results;
      }).finally(() => {
        this.loading = false;
      });
    },
    create(item) {
      // this.items.splice(0, 0, item);
      this.list();
    },
    update(item) {
      this.list();
    },
    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    openFormModal(item) {
      if (!item.id) {
        getWarehouseNumber().then(data => {
          const clonedNew = JSON.parse(JSON.stringify(item));
          if (typeof clonedNew.is_active === "boolean") clonedNew.is_active = String(clonedNew.is_active);
          this.targetItem = { ...clonedNew, number: data.number };
        })
      } else {
        const cloned = JSON.parse(JSON.stringify(item));
        if (typeof cloned.is_active === "boolean") cloned.is_active = String(cloned.is_active);
        this.targetItem = cloned;
      }
      userOption({ page_size: 999999 }).then(data => {
        this.usersOptions = data.results;
      });
      this.visible = true;
    },
    destroy(id) {
      warehouseDestroy({ id }).then(() => {
        // this.items.splice(this.items.findIndex(item => item.id == id), 1);
        this.$message.success('删除成功');
        this.list();
      });
    },
    exportExcel() {
      warehouseExport(this.searchForm).then(resp => {
        exportExcel(resp.data, '仓库字典列表');
      }).catch(err => {
        this.$message.error(err.response.data.error);
      });
    },
    downloadTemplate() {
      warehouseTemplate().then(resp => {
        exportExcel(resp.data, '仓库字典导入模板');
      }).catch(err => {
        this.$message.error(err.response.data.error);
      });
    },
    importExcel(item) {
      let data = new FormData();
      data.append('file', item.file);
      this.importLoading = true;
      setTimeout(() => {
        warehouseImport(data)
          .then(() => {
            this.$message.success('导入成功');
            this.list();
          })
          .catch(err => {
            alert("导入错误:" + "\n" + err.response.data.join("\n"));
          })
          .finally(() => {
            this.importLoading = false;
          });
      }, 1000);
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      if (sorter && sorter.field && sorter.order) {
        this.searchForm.ordering = `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`;
      } else {
        delete this.searchForm.ordering;
      }
      this.list();
    },
  },
}
</script>
